/**
 * Live / Cuidei video attendance service window.
 *
 * Attendance is on-demand and only staffed 09:00–21:00 Brasília time — there is
 * no doctor between 21h and 9h, so patients must not be able to enter the queue.
 * (ECS-650: the last hour was dropped, 22h -> 21h.)
 * The backend enforces this authoritatively (422 on the is_live create); these
 * helpers are for UX so the patient sees the reason instead of a failed payment.
 */
export const LIVE_SERVICE_OPEN_HOUR = 9 // inclusive
export const LIVE_SERVICE_CLOSE_HOUR = 21 // exclusive

export const LIVE_SERVICE_WINDOW_MESSAGE = 'O atendimento por vídeo funciona das 9h às 21h.'

/** Current hour (0–23) in Brasília, independent of the device time zone. */
const brasiliaHour = (): number => {
  const formatted = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Sao_Paulo',
    hour: 'numeric',
    hour12: false
  }).format(new Date())
  const hour = parseInt(formatted, 10)
  // Some environments render midnight as "24" — normalize to 0.
  return Number.isNaN(hour) || hour === 24 ? 0 : hour
}

/** True when live/Cuidei video attendance is currently available. */
export const isLiveServiceOpen = (): boolean => {
  const hour = brasiliaHour()
  return hour >= LIVE_SERVICE_OPEN_HOUR && hour < LIVE_SERVICE_CLOSE_HOUR
}
